import { PageLoader } from '@crehana/compass.ui/v3/page-loader';

// Modern.js mounts it before the page runs `useAddI18nLocales()`, so it keeps
// the default label of `PageLoader`.
export const ContractImportWizardLoading = () => (
  <div className="tw-w-screen tw-h-screen">
    <PageLoader />
  </div>
);
